<template>
	<div class="preview-placeholder">
		<div class="icon-wrapper">
			<font-awesome-icon :icon="['fal', 'ad']" />
		</div>
		<h1 class="preview-welcome-headline">Welcome to Brand Builder</h1>
		<p class="preview-welcome-subheadline" role="heading">
			To get started, let's select the type of media you want to build.
		</p>
	</div>
</template>

<script>
export default {
	name: 'PreviewPlaceholder',
};
</script>

<style lang="scss" scoped>
.preview-placeholder {
	text-align: center;
	display: flex;
	justify-self: center;
	align-self: center;
	flex-direction: column;
}

.icon-wrapper {
	font-size: 40px;
	line-height: 1;
	color: $brand-teal;
}

.preview-welcome-headline {
	@include rem(margin, 8px 0 10px);
	line-height: 1;
}

.preview-welcome-subheadline {
	margin: 0;
	padding: 0;
}
</style>
